export default __webpack_public_path__ + "navigation-examples-route-deserialize-960-106bf6d822f37d290cb8b4dd2bdab35c.png";